export { default } from './InfoBar';
export type { Props, Props as InfoBarProps } from './InfoBar';
